import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateUser.loading;
export const slotsErrorMessage = (state: RootState) => state.slots.error;
export const slotsResponse = (state: RootState) => state.slots.slotsResponse;
